import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { errorMessage } from "../../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await login(form.email, form.password); navigate("/admin"); } catch (err) { setError(errorMessage(err)); } finally { setLoading(false); }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-[var(--navy)] px-4">
      <div className="grid-lines absolute inset-0" />
      <div data-testid="login-page" className="relative w-full max-w-md rounded-2xl border border-white/10 bg-white p-8 shadow-2xl sm:p-10">
        <img src="/logo.png" alt="MarksMan Healthcare" className="h-12 w-auto" />
        <div className="mt-8 flex items-center gap-2 text-[var(--teal)]"><LockKeyhole size={16} /><span className="eyebrow">Content management</span></div>
        <h1 className="mt-2 text-2xl font-bold text-[var(--navy)]">Team sign in</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><label className="label">Email</label><input data-testid="login-email" type="email" required className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div><label className="label">Password</label><input data-testid="login-password" type="password" required className="input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
          {error && <div data-testid="login-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
